import React, { useEffect, useRef, useState } from "react";
import Search from "../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Form, Progress, Select, Table } from "antd";
import svg15 from "../../../assets/svg/svg15.svg";
import CardLoading from "../../../components/CardLoading";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { fetchData } from "../../../features/fetch/fetchSlice";
import { setActiveObj } from "../../../features/obj/objSlice";
import { cashConverter, extractYear, formatText } from "../../../utils";
import moment from "moment";
import ConfirmModal from "../../../components/ConfirmModal";
import { save } from "../../../features/save/saveSlice";
import toast from "react-hot-toast";
import { projStatusData } from "../../../data";

function ProjectsTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { pathname } = useLocation();
  const url = "main_project/fetch_mainprojects";

  const { loading, data, count, activeObjPathCard } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
    activeObjPathCard: state.obj.activeObj["pathwayCard"],
  }));

  const { refetchKey } = useSelector((state) => state.global);

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");
  const [selectId, setSelectId] = useState("ONGOING");

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };
  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "api/v2/main_projects/delete",
        projectId: prodd?.projectId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };
  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        projectSchemeId: null,
        projectYear: null,
        projectStatus: selectId,
        projectName: e.target.value == "" ? null : e.target.value,
        irrigationPathWayIrrigationPathwayId:
          activeObjPathCard?.irrigationPathwayId,
      })
    );
  };

  const handleView = async (item) => {
    await dispatch(
      setActiveObj({
        key: selectId === "PLANNED" ? "plannedProject" : "ongoingProject",
        data: item,
      })
    );
    await navigate(
      selectId === "PLANNED" ? "planned-pipeline-details" : "/project-view"
    );
  };
  const handleViewName = async (item) => {
    await dispatch(
      setActiveObj({
        key: selectId === "PLANNED" ? "plannedProject" : "ongoingProject",
        data: item,
      })
    );
    await navigate(
      selectId === "PLANNED" ? "planned-pipeline-details" : "/project-view"
    );
  };

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Project Name",
      width: "300px",
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.projectName}
          </div>
        );
      },
      sorter: (a, b) => a.projectName.localeCompare(b.projectName),
    },

    {
      title: "Type",
      dataIndex: "projectTypeName",
      sorter: (a, b) => a.projectTypeName.localeCompare(b.projectTypeName),
    },
    {
      title: "Contractor",
      dataIndex: "projectContractor",
      sorter: (a, b) => a.projectContractor.localeCompare(b.projectContractor),
    },
    {
      title: "Implementing Agency",
      dataIndex: "projectAgencyName",
      sorter: (a, b) => a.projectAgencyName.localeCompare(b.projectAgencyName),
    },
    {
      title: "Associated Scheme",
      dataIndex: "projectSchemeAssociatedName",
      sorter: (a, b) =>
        a.projectSchemeAssociatedName.localeCompare(
          b.projectSchemeAssociatedName
        ),
    },
    {
      title: "County",
      dataIndex: "projectCountyName",
      sorter: (a, b) => a.projectCountyName.localeCompare(b.projectCountyName),
    },

    {
      title: "Project Cost",
      dataIndex: "projectCost",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.projectCost.localeCompare(b.projectCost),
    },
    {
      title: "Total Disbursment to Date(Kes.)",
      dataIndex: "projectTotalDisbursement",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) =>
        a.projectTotalDisbursement.localeCompare(b.projectTotalDisbursement),
    },
    {
      title: "Start Date",
      dataIndex: "projectStartDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.projectStartDate).valueOf() -
        moment(b.projectStartDate).valueOf(),
    },
    {
      title: "Progress",
      dataIndex: "projectCompletionRate",
      render: (item) => {
        return <div>{<Progress percent={item} />}</div>;
      },
      sorter: (a, b) =>
        a.projectCompletionRate.localeCompare(b.projectCompletionRate),
    },
    {
      title: "Status",
      dataIndex: "projectStatus",
      render: (item) => {
        const colors = {
          ONGOING: "#7DACDC",
          PLANNED: "#E5E7E9",
          COMPLETED: "#B1E17C",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <button onClick={() => handleView(item)}>
            <img src={svg15} alt="svg15" />
          </button>
        </>
      ),
    },
  ];

  const onFinish = () => {};

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        projectSchemeId: null,
        projectYear: null,
        projectStatus: selectId,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        irrigationPathWayIrrigationPathwayId:
          activeObjPathCard?.irrigationPathwayId,
      })
    );
  }

  useEffect(() => {
    if (refetchKey == 3) {
      fetchTableData();
    }
  }, [selectId, refetchKey]);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="lg:min-h-[88vh] flex flex-col">
      <div className="flex flex-col w-full  flex-1  ">
        <div className="flex items-center justify-between">
          <div className="lg:w-[29.1875rem] w-auto">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search ..."}
            />
          </div>
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            className="w-full lg:w-[15%]"
            form={form}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                projStatusData?.length > 0 &&
                projStatusData?.map((item) => ({
                  value: item?.value,
                  label: item?.label,
                }))
              }
              value={selectId}
              onChange={(value) => setSelectId(value)}
              placeholder="Select"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </Form>
        </div>

        <div className="max-w-full w-full overflow-x-auto">
          <Table
            rowSelection={false}
            className="mt-[1.75rem] w-full"
            scroll={{
              x: "max-content",
            }}
            rowKey={(record) => record?.projectId}
            columns={columns}
            dataSource={data}
            loading={loading}
            pagination={{
              position: ["bottomRight"],
              current: pageIndex + 1,
              total: count,
              pageSize: pageSize,
              onChange: (page, size) => {
                setPageIndex(page - 1);
                setPageSize(size);
                fetchTableData(page - 1, size);
              },
              showSizeChanger: false,
              hideOnSinglePage: true,
            }}
          />
        </div>
      </div>
      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Disable"
      />
    </div>
  );
}

export default ProjectsTable;
